import React from 'react';
import { Icon } from '@iconify/react';

const MuiPagination = ({ count, page, limit, onChange }) => {
  const totalPages = Math.ceil(count / limit);

  const handlePrev = () => {
    if (page > 1) {
      onChange(null, page - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPages) {
      onChange(null, page + 1);
    }
  };

  const handlePageClick = (pageNum) => {
    onChange(null, pageNum);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (page <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (page >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        pages.push(page - 1);
        pages.push(page);
        pages.push(page + 1);
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  return (
    <div className="flex items-center justify-center gap-2">
      <button
        onClick={handlePrev}
        disabled={page <= 1}
        className="px-3 py-2 border border-border-light rounded-lg text-sm font-medium text-text-dark hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Icon icon="mdi:chevron-left" className="text-lg" />
      </button>

      {getPageNumbers().map((pageNum, idx) => {
        if (pageNum === '...') {
          return (
            <span key={`ellipsis-${idx}`} className="px-3 py-2 text-text-secondary">
              ...
            </span>
          );
        }

        return (
          <button
            key={pageNum}
            onClick={() => handlePageClick(pageNum)}
            className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${
              page === pageNum
                ? 'bg-primary text-white border-primary'
                : 'border-border-light text-text-dark hover:bg-gray-50'
            }`}
          >
            {pageNum}
          </button>
        );
      })}

      <button
        onClick={handleNext}
        disabled={page >= totalPages}
        className="px-3 py-2 border border-border-light rounded-lg text-sm font-medium text-text-dark hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Icon icon="mdi:chevron-right" className="text-lg" />
      </button>
    </div>
  );
};

export default MuiPagination;
